import useSWR, { SWRConfiguration } from 'swr'
import { fetcher } from './client'
import { GET_COMPANY_NOTIFICATIONS } from './endpoints'
import { Notification } from './types/notification'

export const useNotification = (config: Partial<SWRConfiguration> = {}) =>
  useSWR<Notification>(GET_COMPANY_NOTIFICATIONS, fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    ...config,
  })
